export const getMargin = (elementId: string, isMinusHeader = false) => {
    const element: any = document.getElementById(elementId)
    if (typeof element != 'undefined' && element != null && element!.clientHeight) {
        let freeHeight = window.innerHeight - getHeaderHeight() - element.clientHeight;
        if(isMinusHeader){
            freeHeight = window.innerHeight - element.clientHeight;
        }
        if (freeHeight > 0) {
            if(isMinusHeader){
                return (freeHeight / 2)
            }else{
                return (freeHeight / 2) + getHeaderHeight()
            }
            // return (freeHeight / 2)
        } else {
            return 0
        }
    }else{
        return 0
    }
}

export const getTop = (elementId: string) => {
    const element: any = document.getElementById(elementId)
    if (typeof element != 'undefined') {
        const freeHeight = window.innerHeight + getHeaderHeight() - element.clientHeight;
        if (freeHeight > 0) {
            return freeHeight / 2
        } else {
            return 0
        }
    }else{
        return 0
    }
}
export const getTopInHeader = (elementId: string) => {
    const element: any = document.getElementById(elementId)
    if (typeof element != 'undefined') {
        const freeHeight = window.innerHeight - element.clientHeight;
        if (freeHeight > 0) {
            return freeHeight / 2
        } else {
            return 0
        }
    }else{
        return 0
    }
}

export const getHeaderHeight =()=>{
    const header: any = document.getElementsByClassName('header')
    if (typeof header != 'undefined' && header.length > 0) {
        return header[0].clientHeight
    }else{
        return 0
    }
}